function NoVenuesCtrl($scope, $state) {
  _initScope();

  function _initScope() {
    $scope.backToOrgSelect = _backToOrgSelect;
  }

  function _backToOrgSelect($event) {
    if ($event) $event.preventDefault();

    $state.go('app.selectOrganization', {
      autoSelect: false
    });
  }
}

NoVenuesCtrl.$inject = [
  '$scope',
  '$state'
];

export default NoVenuesCtrl;



// WEBPACK FOOTER //
// ./src/components/noVenues/noVenuesCtrl.js